require([
    'app',
    'apps/admin/application',
    'common/components/nunjucks-config/main'
], function(app, Application, nunjucksConfig) {
    'use strict';

    var locale = app.initData.get('locale');

    // locale-specific start
    if (locale !== 'en') {
        var jsonUrl = app.get_path('core_static', 'common/components/nunjucks-config/localization/' + locale.toLowerCase() + '.json');

        $.getJSON(
            jsonUrl,

            function (messages) {
                nunjucksConfig.init(
                    function () {
                        var application = new Application();
                        application.start();
                    },
                    messages,
                    locale
                );
            }
        );

        return;
    }

    // normal start
    nunjucksConfig.init(function () {
        var application = new Application();
        application.start();
    });

});

define("apps/admin/main.js", function(){});

